import { MainPageView, } from "./MainPageView.tsx";

export function MainPageModerator() {
  return (
    <MainPageView
      payments={{
        isSuccess: true,
        count: 1,
      }}
      isOperationsHistoryEnabled={true}
    />
  );
}
